<template>
  <BaseDialog
    ref="baseDialog"
    :modal-id="modalId"
    :title="title || $t('confirmDialog.title')"
    :confirm-text="$t('common.confirm')"
    :cancel-text="$t('common.cancel')"
    confirm-variant="danger"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  >
    <template #body>
      <p>{{$t( 'confirmDialog.message') }}</p>
      <p class="text-warning">
        {{ $t('confirmDialog.note') }}
      </p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineProps, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

defineProps({
  modalId: {
    type: String,
    default: 'confirmDialog'
  },
  title: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['confirm', 'cancel']);
const baseDialog = ref(null);
const message = ref('');

const open = (dialogMessage) => {
  message.value = dialogMessage;
  baseDialog.value?.openDialog();
};

const handleConfirm = () => {
  emit('confirm');
  baseDialog.value?.closeDialog();
};

const handleCancel = () => {
  emit('cancel');
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>
